/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration =  Object.assign({
    wishlists: 'smart'
    }, window.boostSDAppConfig.integration || {});
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
      componentRegistry.useComponentPlugin('RecommendationWidget.Slider', {
        name: 'Change number of products in slider #224858',
        apply: () => ({
          props: (props) => {
            if (window.innerWidth > 1024) {
              const hasMoreThanFourProds = props.slides?.length > 4;
              props.slidesToShow = hasMoreThanFourProds ? 4 : props.slidesToShow ;
              props.hasPagination = hasMoreThanFourProds;
              props.enableButtons = hasMoreThanFourProds;
            } 
            if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
              const hasMoreThanThreeProds = props.slides?.length > 3;
              props.slidesToShow = hasMoreThanThreeProds ? 3 : props.slidesToShow ;
              props.hasPagination = hasMoreThanThreeProds;
              props.enableButtons = hasMoreThanThreeProds;
            } 
            return props;
          },
        }),
      });
    }
  ]);
